var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02302IconServiceLoadBalancerHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bcbc686f-7d0e-404b-9edf-70f0e80568de",
    x1: -559.176,
    y1: 1007.063,
    x2: -559.176,
    y2: 1010.919,
    gradientTransform: "matrix(1, 0, 0, -1, 564, 1025.516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#84d332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#86d633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfe832fd-17ab-4d81-b819-7779892041f3",
    x1: -555.849,
    y1: 73.585,
    x2: -555.849,
    y2: 55.904,
    gradientTransform: "translate(564 -54.484)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83b9f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb7bf0f1-7df9-48cd-8cf3-0ff131b07502",
    x1: 8.151,
    y1: 4.178,
    x2: 8.151,
    y2: 10.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.927,14.472H3.721a.119.119,0,0,0-.119.119v3.338a.06.06,0,0,0,.06.06.064.064,0,0,0,.037-.013l1.089-.853a.053.053,0,0,1,.024-.011l0,0,1.238-.965V14.591A.119.119,0,0,0,5.927,14.472Z",
    fill: "url(#bcbc686f-7d0e-404b-9edf-70f0e80568de)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.808,17.109l1.238-.965v1.8A.059.059,0,0,1,5.987,18a.063.063,0,0,1-.037-.012Z",
    fill: "#76bc2d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.871,1.632,3.092.21A.592.592,0,0,1,3.545,0H15.253a.817.817,0,0,1,.894.732h0a.614.614,0,0,1,0,.1V14.288a.572.572,0,0,1-.2.433l-1.311,1.2H2.668l-.817-.332Z",
    fill: "#0078d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.859,1.627,3.605.774A.507.507,0,0,1,3.958.593H14.941a.525.525,0,0,1,.524.524h0V13.837a.522.522,0,0,1-.171.394l-1.17,1.059Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.043,1.611H1.939a.061.061,0,0,0-.061.061h0V15.624a.394.394,0,0,0,.394.382H14.043a.382.382,0,0,0,.382-.382V2.008A.4.4,0,0,0,14.043,1.611Z",
    fill: "url(#bfe832fd-17ab-4d81-b819-7779892041f3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.156,14.123A1.625,1.625,0,1,1,9.781,12.5,1.626,1.626,0,0,1,8.156,14.123Zm0-2.562A.938.938,0,1,0,9.1,12.5.938.938,0,0,0,8.156,11.561Z",
    fill: "#fff",
    opacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.944,6.737H9.906a.071.071,0,0,0-.051.122l.582.582a.083.083,0,0,1,0,.117L8.859,9.137c-.071.07-.122.152-.187.226V5.15a.072.072,0,0,1,.072-.072h.85a.073.073,0,0,0,.051-.123L8.2,3.515a.071.071,0,0,0-.1,0L6.662,4.955a.073.073,0,0,0,.051.123h.843a.08.08,0,0,1,.072.072V9.36c-.064-.073-.115-.154-.184-.223L5.866,7.558a.082.082,0,0,1,0-.117l.581-.582a.072.072,0,0,0,0-.1.07.07,0,0,0-.05-.02H4.359a.071.071,0,0,0-.071.071V8.846a.071.071,0,0,0,.072.071.077.077,0,0,0,.05-.02l.61-.61a.082.082,0,0,1,.117,0L6.715,9.865a3.038,3.038,0,0,1,.726,1.182,1.56,1.56,0,0,1,1.42-.006,3.052,3.052,0,0,1,.726-1.176l1.578-1.578a.083.083,0,0,1,.118,0l.61.61a.074.074,0,0,0,.049.02.073.073,0,0,0,.073-.071V6.808A.072.072,0,0,0,11.944,6.737Z",
    fill: "url(#eb7bf0f1-7df9-48cd-8cf3-0ff131b07502)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02302IconServiceLoadBalancerHub);
export default __webpack_public_path__ + "static/media/02302-icon-service-Load-Balancer-Hub.788b83a40ea860b134db3e73d850f7aa.svg";
export { ForwardRef as ReactComponent };